import { Injectable } from '@angular/core';
import { Router, NavigationStart } from '@angular/router';
import { Observable, Subject } from 'rxjs';
import { TranslateService } from '@ngx-translate/core';

@Injectable()
export class HttpAlertService {
    private subject = new Subject<any>();
    private keepAfterNavigationChange = false;

    constructor(private router: Router, private translate: TranslateService ) {
        router.events.subscribe(event => {
            if (event instanceof NavigationStart) {
                if (this.keepAfterNavigationChange) {
                    this.keepAfterNavigationChange = false;
                } else {
                    this.subject.next();
                }
            }
        });
    }

    success(title: string, description = '', keepAfterNavigationChange = false) {
        let titleTranslated = '';
        let descTranslated = '';
        if (title != null && title.length > 0) {
          this.translate.get(title).subscribe(t => {
            titleTranslated = t;
          });
        }
        if (description != null && description.length > 0) {
          this.translate.get(description).subscribe(t => {
            descTranslated = t;
          });
        }
        this.keepAfterNavigationChange = keepAfterNavigationChange;
        this.subject.next({ type: 'success', desc: descTranslated, text: titleTranslated });
    }

    info(title: string, description = '', keepAfterNavigationChange = false) {
      let titleTranslated = '';
      let descTranslated = '';
      if (title != null && title.length > 0) {
        this.translate.get(title).subscribe(t => {
          titleTranslated = t;
        });
      }
      if (description != null && description.length > 0) {
        this.translate.get(description).subscribe(t => {
          descTranslated = t;
        });
      }
      this.keepAfterNavigationChange = keepAfterNavigationChange;
      this.subject.next({ type: 'info', desc: descTranslated, text: titleTranslated });
    }

    warn(title: string, description = '', keepAfterNavigationChange = false) {
      let titleTranslated = '';
      let descTranslated = '';
      if (title != null && title.length > 0) {
        this.translate.get(title).subscribe(t => {
          titleTranslated = t;
        });
      }
      if (description != null && description.length > 0) {
        this.translate.get(description).subscribe(t => {
          descTranslated = t;
        });
      }
      this.keepAfterNavigationChange = keepAfterNavigationChange;
      this.subject.next({ type: 'warn', desc: descTranslated, text: titleTranslated });
    }

    error(title: string, description = '', keepAfterNavigationChange = false) {
      let titleTranslated = '';
      let descTranslated = '';
      if (title != null && title.length > 0) {
        this.translate.get(title).subscribe(t => {
          titleTranslated = t;
        });
      }
      if (description != null && description.length > 0) {
        this.translate.get(description).subscribe(t => {
          descTranslated = t;
        });
      }
      this.keepAfterNavigationChange = keepAfterNavigationChange;
      this.subject.next({ type: 'error', desc: descTranslated, text: titleTranslated });
    }

    getMessage(): Observable<any> {
        return this.subject.asObservable();
    }
}
